export const codePaths = {
	EDUCATION: "education",
	DEPARTMENT: "department",
	SECTION: "section",
	TITLE: "title",
	RANK: "rank",
	APPLICANT_STATUS: "applicant-status",
	APPLICANT_TEST_RESULT: "applicant-test-result",
	EMPLOYMENT_STATUS: "employment-status",
	TRAINING_COST: "training-cost",
	Relationship: "relationship",
	VehicleStatus: "vehicle-status",
	WorkOrderTypes: "work-order-types",
	WorkOrderStatus: "work-order-status",
	EquipmentTypes: "equipment-types",
	EquipmentStatus: "equipment-status",
	EquipmentConditions: "equipment-conditions",
	EquipmentCategory: "equipment-category",
	InspectionTypes: "inspection-types",
	VehicleServiceRequirements: "vehicle-service-requirements",
	EquipmentServiceRequirements: "equipment-service-requirements",
};

export const securityPaths = {
	PROFILE: "profiles",
	ROLEANDPERMISSION: "roles-permissions",
};

export const FLSAOptions = {
	EXEMPT: "Exempt",
	NON_EXEMPT: "Non Exempt",
};

export const RehireOptions = {
	OK: "OK to rehire",
	NOT_OK: "Do not rehire",
};

export const ImageTypes = {
	Path: "Path",
	Binary: "Binary",
};

export const InputComponentType = {
	TextField: "TextField",
	DatePicker: "DatePicker",
	Dropdown: "Dropdown",
	Checkbox: "Checkbox",
	Radio: "Radio",
	FreeTextDropdown: "FreeTextDropdown",
};

export const customIdPaths = {
	EMPLOYEE_ID: "employee-id",
	COURSE_ID: "course-id",
	CERTIFICATE_ID: "certificate-id",
	PARTICIPANT_ID: "participant-id",
	FLEET_ID: "fleet-id",
	WORKORDER_ID: "work-order-id",
	INSPECTION_ID: "inspection-id",
	FUNDINGSOURCE_ID: "funding-source-id",
	EQUIPMENT_ID: "equipment-id",
	MAINTENANCE_ID: "maintenance-id",
	DISPENSABLE_ID: "dispensable-id",
};

export const perNotesOptions = {
	Employees: "Employees",
	Applicants: "Applicants",
};

export const createRecordFor = {
	Employee: "employee",
	Applicant: "applicant",
};

export const PerTagType = {
	Employee: "perPersonnel",
	Applicant: "perApplicant",
	Course: "trainingCourse",
	Participant: "trainingParticipant",
	Certification: "trainingCertification",
};

export const PerPhotoType = {
	Employee: "perPersonnel",
	Applicant: "perApplicant",
	Inspection: "perInspection",
};

// isAmsRoute: true => AMS-only, false => Asset Sentinel-only, null/undefined => shared route
export const routeToModuleMap = {
	// Employee Routes
	"/employee": { area: "modules", key: "Employees", isAmsRoute: true },
	"/employee/add": { area: "modules", key: "Employees", isAmsRoute: true },
	"/employee/edit/:id": { area: "modules", key: "Employees", isAmsRoute: true },

	// Applicant Routes
	"/applicants": { area: "modules", key: "Applicants", isAmsRoute: true },
	"/applicants/add": { area: "modules", key: "Applicants", isAmsRoute: true },
	"/applicants/edit/:id": { area: "modules", key: "Applicants", isAmsRoute: true },

	// Training Courses Routes
	"/training/courses": { area: "training", key: "Courses", isAmsRoute: true },
	"/training/courses/add": { area: "training", key: "Courses", isAmsRoute: true },
	"/training/courses/edit/:id": { area: "training", key: "Courses", isAmsRoute: true },

	// Training Participants Routes
	"/training/participants": { area: "training", key: "Participants", isAmsRoute: true },
	"/training/participants/add": { area: "training", key: "Participants", isAmsRoute: true },
	"/training/courses/edit/:courseId/participants/add": { area: "training", key: "Participants", isAmsRoute: true },
	"/training/courses/edit/:courseId/participants/edit/:id": { area: "training", key: "Participants", isAmsRoute: true },

	// Training Certifications Routes
	"/training/certifications": { area: "training", key: "Certifications", isAmsRoute: true },
	"/training/certifications/add": { area: "training", key: "Certifications", isAmsRoute: true },
	"/training/certifications/edit/:id": { area: "training", key: "Certifications", isAmsRoute: true },

	// Training Mass Update Route
	"/training/mass-update": { area: "training", key: "Mass Update", isAmsRoute: true },
	
	// Training Summary Route
	"/training/summary": { area: "training", key: "Summary", isAmsRoute: true },

	// Security Routes
	"/security": { area: "modules", key: "Security", isAmsRoute: null },
	"/security/:subpage": { area: "modules", key: "Security", isAmsRoute: null },
	"/security/profiles": { area: "security", key: "Profiles", isAmsRoute: null },
	"/security/roles-permissions": {
		area: "security",
		key: "Roles And Permissions",
		isAmsRoute: null,
	},

	// Code Settings Routes
	"/code-settings": { area: "modules", key: "Codes", isAmsRoute: null },
	"/code-settings/department": { area: "codes", key: "Department", isAmsRoute: null },
	"/code-settings/rank": { area: "codes", key: "Rank", isAmsRoute: null },
	"/code-settings/training-cost": { area: "codes", key: "Training Cost", isAmsRoute: true },
	"/code-settings/title": { area: "codes", key: "Title", isAmsRoute: true },
	"/code-settings/section": { area: "codes", key: "Section", isAmsRoute: true },
	"/code-settings/employment-status": {
		area: "codes",
		key: "Employment Status",
		isAmsRoute: true,
	},
	"/code-settings/education": { area: "codes", key: "Education", isAmsRoute: true },
	"/code-settings/applicant-status": {
		area: "codes",
		key: "Applicant Status",
		isAmsRoute: true,
	},
	"/code-settings/applicant-test-result": {
		area: "codes",
		key: "Applicant Test Result",
		isAmsRoute: true,
	},
	"/code-settings/relationship": {
		area: "codes",
		key: "Relationship",
		isAmsRoute: true,
	},
	
	// Fleet Routes
	"/asset-sentinel/fleet-vehicles": { area: "fleet", key: "Vehicles", isAmsRoute: false },
	"/asset-sentinel/fleet-work-orders": { area: "fleet", key: "Work Orders", isAmsRoute: false },
	"/asset-sentinel/fleet-inspection": { area: "fleet", key: "Inspections", isAmsRoute: false },
	"/asset-sentinel/fleet-inspection-setup": {
		area: "fleet",
		key: "Inspections Setup",
		isAmsRoute: false,
	},
	"/asset-sentinel/fleet-code-maintenance": {
		area: "fleet",
		key: "Code Maintenance",
		isAmsRoute: false,
	},
	"/asset-sentinel/fleet-funding-sources": {
		area: "fleet",
		key: "Funding Sources",
		isAmsRoute: false,
	},
	"/asset-sentinel/fleet-code-maintenance/vehicle-status": {
		area: "codes",
		key: "Vehicle Statuses",
		isAmsRoute: false,
	},
	"/asset-sentinel/fleet-code-maintenance/work-order-types": {
		area: "codes",
		key: "Work Order Types",
		isAmsRoute: false,
	},
	"/asset-sentinel/fleet-code-maintenance/work-order-status": {
		area: "codes",
		key: "Work Order Statuses",
		isAmsRoute: false,
	},
	"/asset-sentinel/fleet-code-maintenance/vehicle-service-requirements": {
		area: "codes",
		key: "Vehicle Service Requirements",
		isAmsRoute: false,
	},

	// Equipment Routes
	"/asset-sentinel/equipment": { area: "equipment", key: "Equipment", isAmsRoute: false },
	"/asset-sentinel/equipment-maintenance": {
		area: "equipment",
		key: "Maintenance",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-code-maintenance": {
		area: "equipment",
		key: "Code Maintenance",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-dispensable-items": {
		area: "equipment",
		key: "Dispensable Items",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-funding-sources": {
		area: "equipment",
		key: "Funding Sources",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-types": {
		area: "codes",
		key: "Equipment Types",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-status": {
		area: "codes",
		key: "Equipment Statuses",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-conditions": {
		area: "codes",
		key: "Equipment Conditions",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-category": {
		area: "codes",
		key: "Equipment Category Codes",
		isAmsRoute: false,
	},
	"/asset-sentinel/equipment-code-maintenance/equipment-service-requirements":
		{ area: "codes", key: "Equipment Service Requirements", isAmsRoute: false },

	// Audit Log Route
	"/asset-sentinel/audit-log": { area: "modules", key: "Audit Logs", isAmsRoute: false },
};
